import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ZoningCodeService } from 'src/app/core/services';
import { CalibrationUsesLabelModel } from 'src/app/models';
import { ImportService } from 'src/app/core/services/import.service';
import useClassOptions from 'src/shared/enums/use-class-options';
import ICalibrationUsesType = ZoneIQCalibration.ICalibrationUsesType;
import IUseClass = ZoneIQCalibration.IUseClass;

interface IUses {
    [key: string]: any;
}
@Component({
    standalone: false,
    selector: 'import-data-dialog',
    templateUrl: './import-data-dialog.component.html',
    styleUrls: ['./import-data-dialog.component.scss']

})
export class DialogImportDataComponent implements OnInit {
    csvData: any;
    usesTypes: ICalibrationUsesType[] = [];
    useClassOptions: IUseClass[] = [];
    selectedClassId: number = useClassOptions[0].Id;

    constructor(
        private readonly zcService: ZoningCodeService,
        public dialogRef: MatDialogRef<DialogImportDataComponent>,
        private readonly importService: ImportService,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    ngOnInit() {
        this.usesTypes = this.zcService.selectedZoningCode.CalibrationUsesTypes;
        this.useClassOptions = this.zcService.useClasses;
    }

    get hasZoningCode() {
        return !!this.zcService.selectedZoningCode;
    }

    get zoningCodeId() {
        return this.hasZoningCode && this.zcService.selectedZoningCode.Id;
    }

    get getInputValue() {
        return this.csvData ? this.csvData.info.name : 'No file chosen ';
    }

    cancel(): void {
        this.dialogRef.close();
    }

    resetInputFile(fileInput) {
        this.csvData = null;
        fileInput.value = '';
    }

    import(usesType: ICalibrationUsesType): void {
        const prevValue = this.data.table;
        const currentData: IUses = [];
        if (usesType && this.csvData.data && this.csvData.data.length) {
            this.csvData.data = this.mapUses(this.zoningCodeId, usesType);
            currentData[usesType.Name] = [].concat(
                this.csvData.data,
                prevValue[usesType.Name] ? prevValue[usesType.Name] : []
            );
            this.dialogRef.close();
        }

        Object.assign(prevValue, currentData);
        prevValue[usesType.Name].sort(CalibrationUsesLabelModel.sortingUsesLabel);

        this.importService.validateUsesLabels();
    }

    csvInputChange(fileInputEvent: any) {
        if (fileInputEvent && fileInputEvent.length > 0) {
            const file: File = fileInputEvent.item(0);

            if (!file.size) {
                return;
            }

            const reader: FileReader = new FileReader();
            reader.readAsText(file);
            reader.onload = () => {
                const data: any = reader.result;
                const parsedData = data
                    .split('\r')
                    .filter(x => x !== '\n' && x !== '')
                    .map(x => x.replace(/['"\n]/g, ''));
                this.csvData = parsedData.length ? { info: fileInputEvent[0], data: parsedData } : null;
            };
        }
    }

    mapUses(zoningCodeId: number, usesType: ICalibrationUsesType) {
        if (!zoningCodeId || !usesType) {
            return;
        }

        const uses: IUses = [];
        this.csvData.data.forEach((label, index) => {
            uses[index] = {
                Label: label,
                ZoningCodeId: zoningCodeId,
                CalibrationUsesTypeId: usesType.Id,
                ClassId: this.selectedClassId
            };
        });

        return uses;
    }
}
